'use strict';
// import './style.css';

export class Geolocation
{
    constructor(options = [])
    {
        this.options = options;
        this.init();
    }

    init()
    {
        const instance = this

        const cityColl = document.querySelectorAll('.js-city-choose')
        if (cityColl) {       
            cityColl.forEach((city) => city.addEventListener("click", function (e) {
                instance.chooseCity(e)
                instance.chooseAddress(e)
            }))
        }
    }

    chooseCity(e) {
        e.preventDefault()
        let city = e.target.text
        document.cookie = 'selected_city=' + city
        document.getElementById('selected-city').textContent = city
    }

    chooseAddress(e) {
        e.preventDefault()
        let address = e.target.getAttribute('data-address')
        if (address) {
            document.cookie = 'selected_address=' + address       
            document.getElementById('selected-address').textContent = address     
        } else {
            document.cookie = 'selected_address' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
            document.getElementById('selected-address').textContent = ''    
        }
    }

}